/**
 * SalvationMeService
 * The volunteer portal: my teams and counts, my people (only those I am Lead or Backup for; campus leaders may see
 * their campus), one person, logging a follow-up, adding someone and my team roster.
 * Route: salvation/api/salvation/me*
 */
import { BaseService } from '../base/BaseService';
import { unwrapSalvationResponse as unwrap, salvationListOrEmpty as listOrEmpty } from './unwrapSalvationResponse';
/** Volunteer portal (api/salvation/me). */
export class SalvationMeService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SalvationMeService.DEFAULT_SERVICE_PATH,
            basePath: SalvationMeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET me: hasAccess=false for people not on a Salvation Team (show "ask your campus leader"). */
    async getMe() {
        return unwrap(await this.getMeRaw(), 'Salvation profile not found');
    }
    getMeRaw() {
        return this.http.get(this.buildUrl());
    }
    /** GET me/people: responsible (default) | lead | backup | growing | all; teamId = a campus leader's whole campus. */
    async getPeople(filter, teamId) {
        return listOrEmpty(await this.getPeopleRaw(filter, teamId));
    }
    getPeopleRaw(filter, teamId) {
        return this.http.get(this.buildUrlWithParams('people', { filter, teamId }));
    }
    /** GET me/people/{id}: one of my people (403 not_assigned for anyone else). */
    async getPerson(convertId) {
        return unwrap(await this.getPersonRaw(convertId), 'Person not found');
    }
    getPersonRaw(convertId) {
        return this.http.get(this.buildUrl(`people/${convertId}`));
    }
    /** POST me/people: add someone to my campus team (409 duplicate_convert unless confirmNotDuplicate). */
    async addPerson(request) {
        return unwrap(await this.addPersonRaw(request), 'The person could not be added');
    }
    addPersonRaw(request) {
        return this.http.post(this.buildUrl('people'), request);
    }
    /** POST me/people/{id}/follow-ups: what happened (409 handover_needs_met unless confirmed). */
    async logFollowUp(convertId, request) {
        return unwrap(await this.logFollowUpRaw(convertId, request), 'The follow-up could not be saved');
    }
    logFollowUpRaw(convertId, request) {
        return this.http.post(this.buildUrl(`people/${convertId}/follow-ups`), request);
    }
    /** GET me/team: my campus team (names, places and pools; no contact details). */
    async getTeam(teamId) {
        return unwrap(await this.getTeamRaw(teamId), 'Team not found');
    }
    getTeamRaw(teamId) {
        return this.http.get(this.buildUrlWithParams('team', { teamId }));
    }
}
SalvationMeService.DEFAULT_SERVICE_PATH = 'salvation';
SalvationMeService.BASE_PATH = 'api/salvation/me';
//# sourceMappingURL=SalvationMeService.js.map